import { connect } from 'react-redux';
import UserWelcomeContainer from './UserWelcomeContainer';

const mapStateToProps = ({ contexts }) => ({
  userInformation: contexts.user
});

export default connect(mapStateToProps)(UserWelcomeContainer);



// WEBPACK FOOTER //
// ./src/components/dashboard/comp/userWelcome/UserWelcomeConnector.js